import { useState, useEffect, useCallback, useRef } from 'react'
import { controlFichajesAPI } from '../services/api'

export const useDiasSinJustificar = (empleado) => {
  const [diasPendientes, setDiasPendientes] = useState([])
  const [loading, setLoading] = useState(true)
  const verificadoRef = useRef(false)
  const empleadoIdRef = useRef(null)

  // Resetear verificación cuando cambia el empleado
  useEffect(() => {
    if (empleado?.id !== empleadoIdRef.current) {
      verificadoRef.current = false
      empleadoIdRef.current = empleado?.id || null
    }
  }, [empleado])

  const cargarDiasPendientes = useCallback(async () => {
    if (!empleado || empleado.rol === 'super_admin') {
      setDiasPendientes([])
      setLoading(false)
      return
    }

    // Ojo: NO se filtra por plan aquí. `verificarAcceso()` es el único
    // disparador de la detección de días sin fichaje en toda la app (el job
    // del backend no se arranca en server.js), así que cortarlo dejaba la
    // tabla `dias_sin_fichaje` vacía para siempre en Pro — y con ella el panel
    // "Días sin fichaje" del admin, que NO es una feature de pago.
    // Lo que distingue a Avanzado es el aviso automático, y ese sí está
    // gateado donde se muestra (AppLayoutV2, popup de días pendientes).
    try {
      if (!verificadoRef.current) {
        verificadoRef.current = true
        try {
          await controlFichajesAPI.verificarAcceso()
        } catch (err) {
          console.error('Error en verificación de acceso:', err)
        }
      }

      const response = await controlFichajesAPI.getPendientes()
      setDiasPendientes(response.data.dias || [])
    } catch (error) {
      console.error('Error cargando días pendientes:', error)
    } finally {
      setLoading(false)
    }
  }, [empleado])

  useEffect(() => {
    cargarDiasPendientes()
  }, [cargarDiasPendientes])

  return { diasPendientes, loading, recargar: cargarDiasPendientes }
}
